import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'notificationsCounter',
})
export class NotificationCounterPipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    if (value == null) {
      return '-'
    } else if (value >= 100) {
      return '99+'
    } else {
      return String(value)
    }
  }
}
